import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { object, string } from 'prop-types';
import FaqTreeList from './FaqTreeList';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

class FaqTreeItem extends Component {
  static propTypes = {
    article: object.isRequired,
    path: string.isRequired,
  };

  static defaultProps = {
    article: {},
    path: '',
  };

  render() {
    const { article, path, closeModal } = this.props;

    return article.children.length > 0 ? (
      <li className="has-child" onClick={closeModal}>
        <NavLink activeClassName="open" to={`/${article.path}`} location={{ pathname: '/' + path }}>
          <span className="faq-tree-list-text">{article.title}</span>
          <SVG
            className="faq-tree-list-icon"
            src={`${STATIC_PATH}/img/action-icons/arrow.svg`}
            height="24"
            width="24"
            cacheRequests
          />
        </NavLink>

        <FaqTreeList className="child-list" key={article.id} pages={article.children} />
      </li>
    ) : (
      <li>
        <NavLink
          activeClassName="current-file"
          to={`/${article.path}`}
          location={{ pathname: '/' + path }}
          onClick={closeModal}
        >
          <span className="faq-tree-list-text">{article.title}</span>
        </NavLink>
      </li>
    );
  }
}

const mapStateToProps = (state) => ({
  path: state.faq.page.path,
});

export default connect(mapStateToProps)(FaqTreeItem);
